<form role="form" [formGroup]="form" novalidate>
    <div class="form-group">
        <label class="form-control-label"> {{ header }} </label>
        <div *ngIf="!showControl" class="d-flex justify-content-center">
            <app-loader-css></app-loader-css>
        </div>
        <div [ngStyle]="{'display': showControl ? 'block' : 'none'}">
            <ng-select [dropdownPosition]="'bottom'" [items]="countryList" bindValue="id" [searchable]="true" bindLabel="name" placeholder="{{ placeholder }}" formControlName="country" [multiple]="false" required>
            </ng-select>
            <div class="text-center invalid-feedback" [ngStyle]="{'display': countryControl.invalid && countryControl.touched ? 'block' : 'none'}">
                <span> {{ error_msg }} </span>
            </div>
        </div>
    </div>
</form>